<!--

EMISSOR DE CUPOM NAO FISCAL


EMISSOR DE CUPOM DE SANGRIA E REFORÇO DE CAIXA

-->

<script>
import { apiORDS } from '../shared/api-functions'
import { formatCNPJCPF, formatValue } from '../shared/utils'

export default {
  props: {
    index: '',
    tipo: '',
  },

  components: {

  },

  filters: {
    changeToFloat: function (value) {
      return value.toFixed(2).replace('.', ',')
    }
  },

  data() {
    return {
      cupom: null,
    }
  },

  computed: {
    urlLogotipo() {
      return this.$store.getters.urlApp + 'logo/download/' + this.cupom.empresa.logo
    },

    curentDate() {
      let data = new Date();
      let dia = String(data.getDate()).padStart(2, '0');
      let horas = `${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`
      let mes = String(data.getMonth() + 1).padStart(2, '0');
      let ano = data.getFullYear();
      let dataAtual = `${dia + '-' + mes + '-' + ano} ${horas}`;
      return dataAtual.toString()
    },

    itemsSum() {
      let total = 0.0
      if (this.cupom && this.cupom.itens)
        this.cupom.itens.map(e => total = e.total + total)
      return (total / 1).toFixed(2).replace('.', ',')
    },
  },

  watch: {

  },

  filters: {

  },

  methods: {

    async loadData() {
      // let tipo = 'cupomnaofiscal'
      // const data = await apiORDS(this.$store.getters.urlOrds + `varejo/cupom/${tipo}/`, {id:1	}) //Index //lTopObject está recebendo obj vazio no ORDS

      const data = await apiORDS(this.$store.getters.urlOrds + 'varejo/cupom/' + this.tipo + '/' + this.index, null)

      // Retorno da requisição está trazendo quando tipo == cupomfiscal data.items(Array) : object{}

      if (this.tipo == 'cupomnaofiscal') {
        this.cupom = data.items[0]
        this.cupom.mensagemCupom = 'Obrigado e volte sempre'
      }
      else {
        this.cupom = data.items[0]
        this.cupom.items = [{ obs: this.cupom.obs, valor: 100 }]
      }
      this.$nextTick(function () {
        this.print()
      });
    },

    print() {

      const prtHtml = document.getElementById('cupom').innerHTML; //CARREGAR TIPO

      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      // const total = formatValue(this.vendaAberta.total_com_desconto,2)
      const total = formatValue(this.cupom.total, 2)

      WinPrint.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              <div>
                <div class="w-100 p-3">
                    ${prtHtml}
                </div>
              </div>
            </body>
          </html>
        `);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();

      this.$emit('resultadoemissaocupom')
    }
  },

  created() {
    this.loadData()
  }

}

</script>

<template>
  <div>
    <!-- VERIFICACAO TIPO DE IMPRESSÃO -->
    <div id="cupom" v-if="cupom && tipo == 'cupomnaofiscal'" style="width:420px">
      <div class="row" v-if="cupom.empresa">
        <div class="img d-flex justify-content-center align-items-center" style="width: 140px; height:70px">
          <img class="img-fluid" :src="urlLogotipo" alt="Cupom_Nao_Fiscal" style="max-width:100px">
        </div>
        <div v-if="cupom && cupom.empresa" class="d-flex flex-column justify-content-start"
          style="margin: 16px 0 !important;">
          <span>{{ cupom.empresa.nome }}</span>
          <span>{{ cupom.empresa.cnpj | formatCNPJCPF }}</span>
          <span class="mt-2">Tel: {{ cupom.empresa.fone | formatFone }}</span>
          <span>
            <span v-if="cupom && cupom.empresa && cupom.empresa.cep">Cep:
              {{ cupom.empresa.cep }} -</span>
            <span class="ml-1" v-if="cupom.empresa.uf">{{ cupom.empresa.uf }}</span>
          </span>
          <span v-if="cupom.empresa.endereco" class="">{{ cupom.empresa.endereco }}
            {{ cupom.empresa.numero }} {{ cupom.empresa.complemento }}</span>
        </div>
      </div>
      <div class="mt-2">
        <div class="d-flex flex-column">
          <span><strong>Caixa:</strong><span class="ml-1">{{ cupom.caixa }}</span></span>
          <span><strong>Cliente:</strong><span class="ml-1">{{ cupom.nomeCliente }}</span></span>
          <span><strong>CNPJ/CPF:</strong><span class="ml-1">{{ cupom.docCliente }}</span></span>
          <span><strong>Pedido:</strong><span class="ml-1">{{ cupom.pedido }}</span></span>
          <span><strong>Data:</strong><span class="ml-1">{{ cupom.data | formatData }}</span></span>
          <span v-if="cupom &&
          cupom.empresa &&
          cupom.empresa.cnpj &&
          cupom.empresa.cnpj.length <= 11">
            <strong>Cliente: </strong>
            <span class="ml-1">Consumidor Final</span>
          </span>
        </div>
        <div>
          <div class="d-flex flex-row mt-1">
            <table v-if="cupom && cupom.itens" border="0" style="width:420px; border-top:none!important;">
              <tr class="border-top:0;" border="0" cellpadding="5px">
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;"><strong>Código</strong>
                </td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;">
                  <strong>Descrição</strong>
                </td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;"><strong>Qtde</strong>
                </td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;"><strong>Valor</strong>
                </td>
                <td style="text-align: center; vertical-align: middle; "><strong>Total</strong></td>
              </tr>
              <tr style="word-break: break-all; border-bottom:1px solid; border-top: 1px solid"
                v-for=" item in cupom.itens" :key="item">
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;">{{ item.codigo }}</td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid; line-height: .85rem">
                  {{ item.descricao }} <br />
                  <small>{{ item.obs }}</small>
                </td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;">{{ item.qt |
                    formatValue(2)
                }}</td>
                <td style="text-align: center; vertical-align: middle; border-right: 1px solid;">{{ item.valor |
                    formatValue(2)
                }}</td>
                <td style="text-align: center; vertical-align: middle; ">{{ item.total | formatValue(2) }}</td>
              </tr>
            </table>
          </div>
          <div class="d-flex flex-column mt-3 pr-1" style="width:424px;">
            <div v-if="cupom && cupom.formas" class="d-flex flex-row" style="width:420px">
              <span class="d-flex flex-column mr-5">
                <strong>Data</strong>
                <span v-for="forma in cupom.formas" :key="forma">
                  {{ forma.data | formatData }}
                </span>
              </span>
              <span class="d-flex flex-column ml-5 mr-5">
                <strong>Forma Pag</strong>
                <span v-for="forma in cupom.formas" :key="forma">
                  {{ forma.forma }}
                </span>
              </span>
              <span class="d-flex flex-column align-self-end ml-auto" style="align-self-end">
                <strong class="text-right">Valor</strong>
                <span class="text-right " v-for="forma in cupom.formas" :key="forma">
                  {{ forma.valor | formatValue(2) }}
                </span>
              </span>
            </div>
            <span class="align-self-end mr-0 mt-2">
              <strong>Sub Total: </strong>
              {{ itemsSum | formatValue(2) }}
            </span>
            <span v-if="cupom && cupom.frete" class="align-self-end mr-0">
              <strong>Frete: </strong>
              {{ cupom.frete | formatValue(2) }}
            </span>
            <span v-if="cupom && cupom.totalDescontos" class="align-self-end mr-0">
              <strong>Desconto: </strong>
              {{ cupom.totalDescontos | formatValue(2) }}
            </span>
            <span v-if="cupom && cupom.totalAcrescimos" class="align-self-end mr-0">
              <strong>Acréscimo: </strong>
              {{ cupom.totalAcrescimos | formatValue(2) }}
            </span>
            <span v-if="cupom && cupom.total" class="align-self-end mr-0">
              <strong>Total: {{ cupom.total | formatValue(2) }}</strong>
            </span>
          </div>
        </div>
        <div class="d-flex flex-column" style="width: 420px;">
          <span v-if="cupom && cupom.mensagemCupom" class="align-self-center mt-2">
            {{ cupom.mensagemCupom }}
            <span></span>
          </span>
          <span class="align-self-center mt-0">{{ curentDate | formatData }}</span>
        </div>
      </div>
    </div>

    <!-- VERIFICACAO TIPO DE IMPRESSAO -->
    <div id="cupom" v-if="cupom && tipo == 'movimentocaixa'">
      <div style="width:420px">
        <div>
          <div class="d-flex flex-row justify-content-center">
            <strong>
              <h5> {{ cupom.tipo }} de Caixa </h5>
            </strong>
          </div>
          <div v-if="cupom.empresa" class="d-flex flex-column mt-3">
            <span><strong class="mr-1">Loja:</strong>{{ cupom.empresa.nome }}</span>
            <span><strong class="mr-1">Operador:</strong>{{ cupom.operador }}</span>
            <span><strong class="mr-1">Data abertura:</strong>{{ cupom.dataAbertura | formatDataHora }}</span>
            <span><strong class="mr-1">Data operação:</strong>{{ cupom.dataMovimento | formatDataHora }}</span>
          </div>
          <div class="d-flex flex-column justify-content-center;">
            <strong class="align-self-center mb-2 mt-3">
              <h5> {{ cupom.caixa }} </h5>
            </strong>
            <table border=1 style="border:1px solid #ededed;">
              <tr>
                <td style="border-right:1px solid #ededed; "><strong>Valor</strong></td>
                <td><strong>Observação</strong></td>
              </tr>
              <tr style="border-color:#ededed;" v-for=" item in cupom.items">
                <td style="width:70px">{{ item.valor | formatValue(2) }}</td>
                <td style="word-break: break-all">{{ item.obs }}</td>
              </tr>
            </table>
          </div>
          <hr class="mt-5" style="background:black; border-color:black; ">
          <h6 class="align-self-center text-center">Assinatura</h6>
        </div>
      </div>
    </div>

    <!-- VERIFICACAO TIPO DE IMPRESSAO -->
    <div id="cupom" v-if="cupom && tipo == 'fechamentocaixa'">
      <div style="width:420px">
        <div>
          <div class="d-flex flex-row justify-content-center">
            <strong>
              <h5> Fechamento de Caixa </h5>
            </strong>
          </div>
          <div v-if="cupom.empresa" class="d-flex flex-column mt-3">
            <span><strong class="mr-1">Loja:</strong>{{ cupom.empresa.nome }}</span>
            <span><strong class="mr-1">Caixa:</strong>{{ cupom.caixa }}</span>
            <span><strong class="mr-1">Operador:</strong>{{ cupom.operador }}</span>
            <span><strong class="mr-1">Data abertura:</strong>{{ cupom.data_abertura | formatDataHora }}</span>
            <span><strong class="mr-1">Valor abertura:</strong>{{ cupom.valor | formatValue(2) }}</span>
            <span><strong class="mr-1">Data fechamento:</strong>{{ cupom.data_fechamento | formatDataHora }}</span>
            <span><strong class="mr-1">Valor fechamento:</strong>{{ cupom.valor_fechamento | formatValue(2) }}</span>
          </div>
          <div class="d-flex flex-column justify-content-center;">
            <strong class="align-self-center mb-2 mt-3">
            </strong>
          </div>
          <hr class="mt-5" style="background:black; border-color:black; ">
          <h6 class="align-self-center text-center">Assinatura</h6>
        </div>
      </div>
    </div>

  </div>
</template>


<style scoped>
#cupom {
  visibility: hidden;
}

span,
p {
  font-size: 13px !important;
}

table {
  font-size: 13px !important;
}

h6,
h5 {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/forms-varejo/varejo-emissao-cupom.vue